<template>
  <div class="content">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="relaWarning">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 实时预警
        </span>
        <div class="w_normalNav">
          <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
          <button class="OrangeSmBtn" @click="reset">重置</button>
        </div>
        <div class="searchForm1">
          <el-form ref="seefrom" class="uLabelDcontent" :model="searchForm">
            <el-form-item label="预警级别">
              <el-select v-model="searchForm.level" placeholder="请选择">
                <el-option v-for="item in levelArr" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="开始时间">
              <el-date-picker v-model="searchForm.startTime" type="datetime" placeholder="请选择开始时间" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间">
              <el-date-picker v-model="searchForm.endTime" type="datetime" placeholder="请选择结束时间" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="预警位置">
              <el-input placeholder="请选择预警位置" v-model="searchForm.curAreaName" @focus="changeAreaMode(1)"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="tableWrapper">
          <el-table :data="tableData" style="width: 100%" class="stripeTable" height="500" ref="Table">
            <el-table-column show-overflow-tooltip :label="label" :prop="prop" :align="align" v-for="({prop,label,align}) in config" :key="prop.toString()">
            </el-table-column>
            <el-table-column label="操作" width="230">
              <template slot-scope="scope">
                <el-link icon="iconfont iconcheck" type="text" size="small" @click="check(scope.row)">详情</el-link>
              </template>
            </el-table-column>
          </el-table>
          <div class="footer">
            <el-pagination layout="prev, pager, next" :page-size="10" @current-change="handleCurrentChange" :total="nTotal" :current-page="currentPage"></el-pagination>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-dialog :visible.sync="detailDialog" class="editDialog realWarning" title="详情">
      <el-form :model="detailData" ref='detailData'>
        <el-form-item label="预警级别:" prop="levelName">
          <p>{{ detailData.levelName }}</p>
        </el-form-item>
        <el-form-item label="预警时间:" prop="createTime">
          <p>{{ detailData.createTime}}</p>
        </el-form-item>
        <el-form-item label="预警位置:" prop="areaName">
          <p>{{ detailData.areaName }}</p>
        </el-form-item>
        <el-form-item label="预警内容:" prop="content">
          <p>{{ detailData.content }}</p>
        </el-form-item>
      </el-form>
    </el-dialog>
    <mountPoint :hasChildNodes="areaTreeMode" :dialogVisible="areaTreeVisible" @regionTreeClose="areaTreeVisible = false" @regionTreeData="selRegionData"></mountPoint>
  </div>
</template>

<script>
import { date } from 'utils'
export default {
  data() {
    return {
      tabName: 'relaWarning',
      searchForm: {},
      addressArr: [],
      levelArr: [
        {
          label: '红色预警',
          value: 4
        },
        {
          label: '橙色预警',
          value: 3
        },
        {
          label: '黄色预警',
          value: 2
        },
        {
          label: '蓝色预警',
          value: 1
        },
        {
          label: '绿色预警',
          value: 0
        }
      ],
      tableData: [],
      currentPage: 1,
      nTotal: 0,
      //区域树是否显示
      areaTreeVisible: false,
      inputReadOnly: false,
      //区域树模式选择
      areaTreeMode: true,
      //选择区域树模式 查询 ？ 新增 ？
      areaMode: 1,
      detailData: {},
      detailDialog: false
    }
  },
  components: {
    mountPoint: () => import('public/mountPoint')
  },
  computed: {
    config() {
      return [
        {
          prop: 'levelName',
          label: '预警级别'
        },
        {
          prop: 'createTime',
          label: '预警时间'
        },
        {
          prop: 'areaName',
          label: '预警位置'
        },
        {
          prop: 'content',
          label: '预警内容'
        }
      ]
    }
  },
  mounted() {
    this.getTableData()
  },
  methods: {
    subSeefrom() {
      this.currentPage = 1
      this.getTableData()
    },
    reset() {
      this.searchForm = {}
    },
    //选择区域模式变化
    changeAreaMode(mode) {
      this.areaTreeVisible = true
      if (mode === 1) this.areaTreeMode = true
      this.areaMode = mode
    },
    //区域树选择完回调
    selRegionData(a, ...b) {
      let mode = this.areaMode
      if (mode === 1) {
        this.searchForm.areaId = a.id
        this.searchForm.curAreaName = a.name
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getTableData()
    },
    isMaxGtMin() {
      if (!this.searchForm.startTime || !this.searchForm.endTime) return true
      let s = date(this.searchForm.startTime)
      let e = date(this.searchForm.endTime)
      let ns = [s.YY, s.MM, s.DD].join('')
      let ne = [e.YY, e.MM, e.DD].join('')
      return ne > ns ? true : false
    },
    getTableData() {
      if (this.searchForm.startTime && this.searchForm.endTime) {
        if (!this.isMaxGtMin()) {
          this.$notify({
            message: '开始时间需小于结束时间',
            type: 'warning'
          })
          return
        }
      }
      this.$axiosget('operation/warningInfo', {
        params: {
          pageSize: 10,
          pageNum: this.currentPage,
          ...this.searchForm
        }
      }).then((res) => {
        this.tableData = res.data.data.list
        this.nTotal = res.data.data.total
      })
    },
    check(row) {
      this.detailData = row
      this.detailDialog = true
    }
  }
}
</script>

<style>
.w_normalNav {
  padding-top: 10px;
  height: 52px;
  position: absolute;
  top: -52px;
  right: 32px;
  z-index: 99;
}
</style>
<style lang="less" scoped>
/deep/ .uLabelDcontent .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}

/deep/ .realWarning .el-dialog__body {
  padding-top: 20px;

  .el-form-item__label {
    width: 120px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/warningManage/relaWarning/index.vue